<template>
  <v-row dense align="center">
    <v-col cols="1" class="text-center">
      <v-progress-circular size="20" width="2" color="green" indeterminate v-if="value===0"/>
      <v-icon v-else-if="value===1" color="green">mdi-check-circle</v-icon>
      <v-icon v-else color="green">mdi-checkbox-blank-circle-outline</v-icon>
    </v-col>
    <v-col cols="6">{{text}}</v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AppsQboSyncItem',
  props: {
    value: {type:Number, required:false},
    text: {type:String, required:true},
  }
}
</script>